import React from 'react';
import { LoremIpsum } from '../components/lorem-ipsum/LoremIpsum';

const LoremIpsumPage: React.FC = () => {
  return <LoremIpsum />;
};

export default LoremIpsumPage;
